module.exports = __webpack_public_path__ + "d1743980d395606d1f0fc89b89a1bd78.svg";